<template>

<div align="justify">
    <!--<p class="h4" align="center">Сайт организации ООО "АИС"</p>-->
    <div align="justify" style="padding: 10px;">
        
        <h3 align="center">
        ПО DataMatrix. Поддержка.
        </h3>
        
        <p>
            Демонстрация работы с продуктом должна быть предварительно согласована с Разработчиком посредством общения через электронную почту <strong style="color: blue;">office@ais-center.ru</strong>.
        </p>
        <p>
            Заявка на устранение выявленной Клиентом неисправности ПО должна быть направлена письмом на адрес электронной почты Разработчика <strong style="color: blue;">office@ais-center.ru</strong> или передана по рабочему телефону <strong style="color: blue;">8 (8216) 76-33-06</strong> с развёрнутым описанием и (при возможности) демонстрацией проблемы.
        </p>

        <p>
            Доработка ПО «Сканер Data Matrix» осуществляется после получения Разработчиком запроса от Клиента, который направляется письмом на адрес электронной почты Разработчика <strong style="color: blue;">office@ais-center.ru</strong> или сообщается по рабочему телефону <strong style="color: blue;">8 (8216) 76-33-06</strong>.
        </p>
        
    </div>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    methods: {
        func1: function(){
            alert("+++");
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    
</style>

